import { Page } from '@/core/architecture'

import { ResaleRaffleDetailCancelCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * resaleRaffleDetailCancelCompletion Page
 * Implemented as a practical sample.
 */
export const ResaleRaffleDetailCancelCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ResaleRaffleDetailCancelCompletionTemplate state={state} {...actions} />
  )
}
